import { Stack } from '@mantine/core';
import DeviceMeasurements from 'pages/revisions-module/template-editor/editors/form/device/DeviceMeasurements';
import DeviceProperties from 'pages/revisions-module/template-editor/editors/form/device/DeviceProperties';
import DeviceFaults from 'pages/revisions-module/template-editor/editors/form/device/DeviceFaults';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * Special case for the devices tab.
 */
export default function DevicesTab() {
  const { isTablet } = useResponsiveDesign();
  return (
    <Stack spacing={isTablet ? 20 : 40}>
      <DeviceProperties />
      <DeviceFaults />
      <DeviceMeasurements />
    </Stack>
  );
}
